import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../utils/apiService';
import { NotiCreateReq, NotificationInterface } from '../../interface/notification';
import { AbstractStateInterface } from '../../interface/abstract';

type DataState = AbstractStateInterface<NotificationInterface>;
const initialState: DataState = {
  data: [],
  detail: null,
  loading: false,
};

export const createNotification = createAsyncThunk('api/firebase', async (payload: NotiCreateReq, thunkAPI) => {
  try {
    const response = await ApiService(`api/firebase`, 'POST', payload);
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    return {
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});
const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    resetNotificationSlice: () => {
      return { ...initialState };
    },
  },
});
export const { resetNotificationSlice } = notificationSlice.actions;
export default notificationSlice.reducer;
